import {Injectable} from '@angular/core';
import CryptoJS from 'crypto-js';

// const generateSecretKey = (): string => {
// 	const keyLength = 32; // 32 bytes = 256 bits (AES-256)
// 	const buffer = new Uint8Array(keyLength);
// 	crypto.getRandomValues(buffer);
// 	return Array.from(buffer, (byte) => byte.toString(16).padStart(2, '0')).join('');
// };

@Injectable({providedIn: 'root'})
export class StorageService {

	key = '123'; //generateSecretKey();

	private encrypt(txt: string): string {
		return CryptoJS.AES.encrypt(txt, this.key).toString();
	}

	private decrypt(txtToDecrypt: string): string {
		return JSON.parse(CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8));
	}

	setItemLocal(itemKey: string, itemObject: string): void {
		const encryptedValue = this.encrypt(JSON.stringify(itemObject));
		return localStorage.setItem(itemKey, encryptedValue);
	}

	setItemSession(itemKey: string, itemObject: string): void {
		const encryptedValue = this.encrypt(JSON.stringify(itemObject));
		return sessionStorage.setItem(itemKey, encryptedValue);
	}

	getItemLocal(itemKey: string): any {
		const itemFromStorage = localStorage.getItem(itemKey);
		return itemFromStorage ? this.decrypt(itemFromStorage) : null;
	}

	getItemSession(itemKey: string): any {
		const itemFromStorage = sessionStorage.getItem(itemKey);
		return itemFromStorage ? this.decrypt(itemFromStorage) : null;
	}

	hasItemLocal(itemKey: string): boolean {
		return !!localStorage.getItem(itemKey);
	}

	hasItemSession(itemKey: string): boolean {
		return !!sessionStorage.getItem(itemKey);
	}

	removeItemLocal(itemKey: string): void {
		localStorage.removeItem(itemKey);
	}

	removeItemSession(itemKey: string): void {
		sessionStorage.removeItem(itemKey);
	}

	removeItemsLocal(...itemKeys: string[]): void {
		itemKeys.forEach(key => this.removeItemLocal(key));
	}

	removeItemsSession(...itemKeys: string[]): void {
		itemKeys.forEach(key => this.removeItemSession(key));
	}

	clearLocal(): void {
		localStorage.clear();
	}

	clearSession(): void {
		sessionStorage.clear();
	}

	clearAll(): void {
		localStorage.clear();
		sessionStorage.clear();
	}

}
